import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "loading-wrapper" }
const _hoisted_3 = { class: "header_wrapper" }
const _hoisted_4 = {
  style: {"width":"48px"},
  class: "d-flex justify-start"
}
const _hoisted_5 = {
  style: {"width":"48px"},
  class: "d-flex justify-end"
}
const _hoisted_6 = { class: "pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vue_loading, {
        loader: "bars",
        active: _ctx.fetchLoading,
        color: "#EE6090",
        size: { width: '50px', height: '50px' }
      }, null, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.routerBack,
              icon: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_v_toolbar_title, { style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0"} }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" 請求書 ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_btn, {
              icon: "",
              disabled: "",
              style: {"visibility":"hidden"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_list, {
      density: "compact",
      style: {"margin-top":"4px"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: c.childId
          }, [
            _createVNode(_component_v_list_item, {
              onClick: ($event: any) => (_ctx.to(c.childId, c.lastName + c.firstName))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, { class: "ml-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: c.imageUrl ? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              append: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (c.noneRead)
                    ? (_openBlock(), _createBlock(_component_v_badge, {
                        key: 0,
                        dot: "",
                        color: "red",
                        inline: ""
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, {
                  textContent: _toDisplayString(c.lastName + c.firstName)
                }, null, 8, ["textContent"])
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_v_divider)
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ]))
}